export default {
  SET_USER_INFO: "SET_USER_INFO", //  设置用户信息
  SET_ORIGANIZATION: "SET_ORIGANIZATION", //  设置组织结构
  SET_HEADER_INFO: "SET_HEADER_INFO", // 设置header的标题
  UPDATE_SYSTEMSET_DATA: "UPDATE_SYSTEMSET_DATA", //修改设置信息
  SET_WX_CONFIG: 'SET_WX_CONFIG'
};
